<template>
  <SettleBillList :fixed-status="0" />
</template>
<script lang="ts" setup>
import SettleBillList from './SettleBillList.vue'
defineOptions({ name: 'TradeAreaAgentSettleStatus0' })
</script>
